<template>
  <div class="mx-sm-1 mt-9">
    <div class="page-header">
      <h1 class="page-title fw-bold">Rapatriement états financiers existants</h1>
      <div>
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link :to="{ name: 'dashboard' }">Tableau de bord</router-link>
          </li>
          <li class="breadcrumb-item active" aria-current="page">
            <router-link :to="{ name: 'classeurs' }">Rapatriement états financiers existants</router-link>
          </li>
        </ol>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <div class="card">
          <div class="card-header d-flex justify-content-between align-items-center">
            <div class="card-options">
              <div class="btn-group">
                <div class="d-flex gap-2">
                  <button
                      class="btn btn-primary btn-sm"
                      @click="displayFomUpload()"
                  >
                    <i class="fe fe-plus-circle me-1"></i>
                   Ajouter
                  </button>

                </div>
              </div>
            </div>
          </div>
          <div class="card-body">


            <div class="table-responsive">
              <table class="table table-hover table-bordered text-nowrap mb-0">
                <thead class="border-top success02">
                <tr>
                  <th>N°</th>
                  <th>ID PTA ASIN</th>
                  <th>ID Budget</th>
                  <th>Report BN</th>
                  <th>Report PRET</th>
                  <th>Report DON</th>
                  <th>Report ANT</th>
                  <th>Report BA</th>
                  <th>Total Report</th>
                </tr>
                </thead>
                <tbody v-if="importedData.length > 0" id="myTable1">
                <tr
                    v-for="(row, index) in paginatedData"
                    :key="index"
                    :class="{ 'bg-danger-transparent': hasRowErrors(row) }"
                >
                  <td>{{ (currentPage - 1) * itemsPerPage + index + 1 }}</td>
                  <td>
                    {{ row.id_pta_asn }}
                    <span v-if="row.errors?.id_pta_asn" class="badge bg-danger ms-1">{{ row.errors.id_pta_asn }}</span>
                  </td>
                  <td>{{ row.id_budget }}
                    <span v-if="row.errors?.id_budget" class="badge bg-danger ms-1">{{ row.errors.id_budget }}</span></td>
                  <td>
                    {{ row.report_bn }}
                    <span v-if="row.errors?.report_bn" class="badge bg-danger ms-1">{{ row.errors.report_bn }}</span>
                  </td>
                  <td>{{ row.report_pret }}
                    <span v-if="row.errors?.report_pret" class="badge bg-danger ms-1">{{ row.errors.report_pret }}</span>
                  </td>
                  <td>{{ row.report_don }}
                    <span v-if="row.errors?.report_don" class="badge bg-danger ms-1">{{ row.errors.report_don }}</span>
                  </td>
                  <td>{{ row.report_ant }}
                    <span v-if="row.errors?.report_ant" class="badge bg-danger ms-1">{{ row.errors.report_ant }}</span>
                  </td>
                  <td>{{ row.report_ba }}
                    <span v-if="row.errors?.report_ba" class="badge bg-danger ms-1">{{ row.errors.report_ba }}</span>
                  </td>
                  <td>
                    {{ row.total_report }}
                    <span v-if="row.errors?.total_report" class="badge bg-danger ms-1">{{ row.errors.total_report }}</span>
                  </td>
                </tr>
                </tbody>
                <tbody v-else>
                <tr class="primary02">
                  <td colspan="9" class="text-center">Aucune donnée trouvée</td>
                </tr>
                </tbody>
              </table>
            </div>
            <div v-if="importedData.length > 0" class="mt-3 d-flex justify-content-between align-items-center">
              <button class="btn btn-sm btn-primary" @click="currentPage--" :disabled="currentPage === 1">Précédent</button>
              <span>Page {{ currentPage }} / {{ totalPages }}</span>
              <button class="btn btn-sm btn-primary" @click="currentPage++" :disabled="currentPage === totalPages">Suivant</button>
            </div>
          </div>
        </div>
      </div>
    </div>


    <!-- Modal -->
    <div class="modal fade"  id="modal-upload-form" tabindex="-1" role="dialog" style="background-color: rgba(0, 0, 0, 0.5);">
      <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header bg-primary text-white">
            <h6 class="modal-title fw-bold" style="font-size: 16px;">{{ modalTitle }}</h6>
            <button aria-label="Close" class="btn-close text-white" data-bs-dismiss="modal"
                    type="button"><span aria-hidden="true">×</span></button>
          </div>

          <div class="modal-body">
            <ValidationObserver ref="observer" v-slot="{ invalid }">
              <form @submit.prevent="handleFormSubmit">
                <div class="form-row">
                  <div class="form-group col-md-3 mb-2">
                    <ValidationProvider name="PTA" rules="required" v-slot="{ errors }">
                      <label class="form-label">PTA <span class="text-danger">*</span></label>
                      <multi-select
                          disabled
                          :options="[payload.idPta]"
                          placeholder="Sélectionnez une activité PTA"
                          label="description"
                          track-by="id"
                          :searchable="false"
                          v-model="payload.idPta"
                          :custom-label="o => o.description"
                      >
                        <template slot="singleLabel" slot-scope="{ option }">
                          <strong> {{ option.description }}</strong>
                        </template>
                        <span slot="noOptions"><strong>Liste Vide</strong></span>
                        <span slot="noResult"><strong>Aucun Résultat</strong></span>
                      </multi-select>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </ValidationProvider>
                  </div>
                  <div class="form-group col-md-3 mb-2">
                    <label class="form-label">Année PTA</label>
                    <input type="text" class="form-control"  :value="payload.idPta?.annee?.annee" placeholder="Année PTA" />
                  </div>

                  <div class="form-group col-md-6 mb-2">
                    <ValidationProvider name="Description" rules="required" v-slot="{ errors }">
                      <label for="description" class="form-label">Description <span class="text-danger">*</span></label>
                      <textarea id="description" class="form-control" v-model="payload.description" placeholder="Description" rows="3"></textarea>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </ValidationProvider>
                  </div>


                </div>

                <div class="form-row">

                  <div class="form-group col-md-4 mb-2">
                    <ValidationProvider name="Type de livrable" rules="required" v-slot="{ errors }">
                      <label class="form-label">Type de livrable <span class="text-danger">*</span></label>
                      <multi-select
                          :options="typeLivrables"
                          placeholder="Sélectionnez un type de livrable"
                          label="libTypeLivrable"
                          track-by="id"
                          :searchable="true"
                          v-model="payload.idTypeLivrable"
                          :custom-label="o => o.libTypeLivrable"
                      >
                        <template slot="singleLabel" slot-scope="{ option }">
                          <strong> {{ option.libTypeLivrable }}</strong>
                        </template>
                        <span slot="noOptions"><strong>Liste Vide</strong></span>
                        <span slot="noResult"><strong>Aucun Résultat</strong></span>
                      </multi-select>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </ValidationProvider>
                  </div>

                  <div class="form-group col-md-4 mb-2">
                    <ValidationProvider name="Phase concernée" rules="required" v-slot="{ errors }">
                      <label class="form-label">Phase concernée <span class="text-danger">*</span></label>
                      <GenericSelect
                          v-model="payload.phaseConcernee"
                          :options="phaseExecutions"
                          label-key="nomPhase"
                          track-key="idPhase"
                          placeholder="Sélectionnez une phase"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </ValidationProvider>
                  </div>
                  <div class="form-group col-md-4 mb-2">
                    <ValidationProvider name="Priorité" rules="required" v-slot="{ errors }">
                      <label class="form-label">Priorité <span class="text-danger">*</span></label>
                      <GenericSelect
                          v-model="payload.priorite"
                          :options="allPriorities"
                          label-key="libelle"
                          track-key="priorite"
                          placeholder="Sélectionnez une priorité"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </ValidationProvider>
                  </div>

                </div>

                <div class="form-row">
                  <div class="form-group col-md-4 mb-2">
                    <!--        <ValidationProvider name="Entité en charge" rules="required" v-slot="{ errors }">-->
                    <label class="form-label">Entité en charge <span class="text-danger">*</span></label>
                    <GenericSelect
                        v-model="payload.entiteCharge"
                        :options="entiteTraitements"
                        label-key="nomEntite"
                        track-key="idEntite"
                        placeholder="Sélectionnez une Entité en charge"
                    />
                    <!--          <small class="text-danger">{{ errors[0] }}</small>-->
                    <!--        </ValidationProvider>-->
                  </div>
                  <div class="form-group col-md-4 mb-2">
                    <ValidationProvider name="Référent PMO" rules="required" v-slot="{ errors }">
                      <label class="form-label">Référent PMO <span class="text-danger">*</span></label>
                      <GenericSelect
                          v-model="payload.referentPmo"
                          :options="contacts"
                          label-key="nom"
                          track-key="idContact"
                          placeholder="Sélectionnez un Référent PMO"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </ValidationProvider>
                  </div>
                  <div class="form-group col-md-4 mb-2">
                    <ValidationProvider name="Point Focal ASIN" rules="required" v-slot="{ errors }">
                      <label class="form-label">Point Focal ASIN <span class="text-danger">*</span></label>
                      <GenericSelect
                          v-model="payload.pointFocalAsin"
                          :options="contacts"
                          label-key="nom"
                          track-key="idContact"
                          placeholder="Sélectionnez le Point Focal ASIN"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </ValidationProvider>
                  </div>

                </div>

                <div class="form-row">
                  <div class="form-group col-md-4 mb-2">
                    <ValidationProvider name="Pôle" rules="required" v-slot="{ errors }">
                      <label class="form-label">Pôle</label>
                      <GenericSelect
                          v-model="payload.pole"
                          :options="allPoles"
                          label-key="nomPole"
                          track-key="idPole"
                          placeholder="Sélectionnez le Pôle"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </ValidationProvider>
                  </div>

                  <div class="form-group col-md-4 mb-2">
                    <ValidationProvider name="Lot" rules="required" v-slot="{ errors }">
                      <label class="form-label">Lot <span class="text-danger">*</span></label>
                      <input type="text" class="form-control" v-model="payload.lot" placeholder="Lot" />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </ValidationProvider>
                  </div>

                  <div class="form-group col-md-4 mb-2">
                    <ValidationProvider name="Statut" rules="required" v-slot="{ errors }">
                      <label class="form-label">Statut</label>
                      <GenericSelect
                          v-model="payload.statut"
                          :options="allStatus"
                          label-key="libelle"
                          track-key="valeur"
                          placeholder="Sélectionnez le Statut"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </ValidationProvider>
                  </div>

                </div>

                <div class="form-row">
                  <div class="form-group col-md-4 mb-2">
                    <ValidationProvider name="ASIN Lead" rules="required" v-slot="{ errors }">
                      <label class="form-label">ASIN Lead</label>
                      <input type="text" class="form-control" v-model="payload.asinLead" placeholder="ASIN Lead" />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </ValidationProvider>
                  </div>
                  <div class="form-group col-md-4 mb-2">
                    <ValidationProvider name="% Réalisation" rules="required" v-slot="{ errors }">
                      <label class="form-label">% Réalisation</label>
                      <input type="number" step="0.01" class="form-control" v-model="payload.pctRealisation" placeholder="% Réalisation" />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </ValidationProvider>
                  </div>

                  <div class="form-group col-md-4 mb-2">
                    <ValidationProvider name="Retard" rules="required" v-slot="{ errors }">
                      <label class="form-label">Retard</label>
                      <input type="text" class="form-control" v-model="payload.retard" placeholder="Retard" />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </ValidationProvider>
                  </div>

                </div>

                <div class="form-row">

                  <div class="form-group col-md-4 mb-2">
                    <ValidationProvider name="Revue PMO" rules="required" v-slot="{ errors }">
                      <label class="form-label">Revue PMO</label>
                      <input type="text" class="form-control" v-model="payload.revuePmo" placeholder="Revue PMO" />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </ValidationProvider>
                  </div>
                  <div class="form-group col-md-4 mb-2">
                    <ValidationProvider name="Date prévue revue PMO" rules="required|date_format_yyyy_mm_dd" v-slot="{ errors }">
                      <label class="form-label">Date prévue revue PMO</label>
                      <input type="date" class="form-control" v-model="payload.datePrevueRevuePmo" />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </ValidationProvider>
                  </div>
                  <div class="form-group col-md-4 mb-2">
                    <ValidationProvider name="Date prévue revue DG" rules="required|date_format_yyyy_mm_dd" v-slot="{ errors }">
                      <label class="form-label">Date prévue revue DG</label>
                      <input type="date" class="form-control" v-model="payload.datePrevueRevueDg" />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </ValidationProvider>
                  </div>
                </div>


                <div class="form-group text-end mt-3">
                  <button class="btn btn-gray me-2" type="button" data-bs-dismiss="modal" >Annuler</button>
                  <button class="btn btn-success" type="submit" :disabled="invalid">
                    <span class="fe" :class="isEditing ? 'fe-edit' : 'fe-check'"></span>
                    {{ isEditing ? 'Modifier' : 'Enregistrer' }}
                  </button>
                </div>
              </form>
            </ValidationObserver>
          </div>


      </div>
    </div>
    </div>

  </div>
</template>
<script>

  export default {
    name: "Client",
    data() {
      return {
        payload: {
          exercice: null,
          fichier: null,
        },
        exercices : [],
        currentPage: 1,
        itemsPerPage: 10,
        importedData: []
      }
    },
    mounted() {
    },
    computed: {
      paginatedData() {
        const start = (this.currentPage - 1) * this.itemsPerPage;
        return this.importedData.slice(start, start + this.itemsPerPage);
      },
      totalPages() {
        return Math.ceil(this.importedData.length / this.itemsPerPage);
      },
      hasAnyErrors() {
        return this.importedData.some(row => row.errors && Object.keys(row.errors).length > 0);
      }
    },
    methods : {
      displayFomUpload(){
        $('#modal-upload-form').modal('show');
      },
      async handleFormSubmit() {
        console.log("Headers nettoyés :", this.payload);
        $('#modal-upload-form').modal('hide');
      },



      getExercices() {
        this.$loading(true);
        this.$http.get('/exercice')
            .then(({data}) => {
              console.log(data);
              console.log(1);
              this.exercices = data;
              this.$loading(false);

            });
      },
    },
    created() {

      this.getExercices()


    },
  }
</script>


<style scoped>

</style>